import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Contracts, type ContractFields } from "@/api/contracts";
import { apiErrorMessage } from "@/api/client";
import { toast } from "@/lib/feedback";

/** Save one change to the contract and put the fresh copy in the cache. */
export function useContractSave(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (patch: ContractFields) => Contracts.update(id, patch),
    onSuccess: (d) => {
      qc.setQueryData(["contract", id], d);
      void qc.invalidateQueries({ queryKey: ["contracts"] });
    },
    onError: (e) => toast.err(apiErrorMessage(e)),
  });
}
